import styled from 'styled-components';

export const Container = styled.div`
h2 {
    color: #0C2B6E;
    font-family: 'Raleway', sans-serif;
    margin: 10px 0;
    font-weight: 700;
     @media (max-width: 400px) {
        font-size: 25px;   /* Ajusta o tamanho em telas menores */
     }
  }
     h4 {
    color: #0C2B6E;
    font-family: 'Raleway', sans-serif;
    margin: 20px 0;
    font-weight: 700;
     @media (max-width: 400px) {
        font-size: 20px;   /* Ajusta o tamanho em telas menores */
     }
  }
  min-height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: #f0f2f5;
  padding: 20px;
  box-sizing: border-box;
  position: relative;
`;

export const CenterDiv = styled.div`
  background: #FFF;
  text-align: center;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 720px;
  box-sizing: border-box;
  position: relative; 
`;


export const ButtonLogin = styled.button`
  width: auto;
  padding: 10px 25px;
  border-radius: 40px;
  border: none;
  font-family: 'Raleway', sans-serif;
  font-weight: 700;
  font-size: 20px;
  height: 50px;
  background: linear-gradient(268.2deg, #006EB0 -5.28%, #00AFEF 100%, #007DC3 100%);
  position: relative;
  margin-top: 20px;
`;

export const InputLogin = styled.input`
  height: 50px;
  width: 100%;
  border-radius: 40px;
  text-align: left;
  padding: 10px 25px;
  font-family: 'Raleway', sans-serif;
  font-weight: 400;
  font-size: 16px;
`;

export const SelectLogin = styled.select`
  height: 50px;
  width: 100%;
  border-radius: 40px;
  padding: 10px 25px;
  font-family: 'Raleway', sans-serif;
  font-weight: 400;
  font-size: 16px;
`;

export const LogoImage = styled.img`
  width: 150px; /* Largura da logo em telas grandes */

  /* Ajustes para telas menores */
  @media (max-width: 768px) {
    width: 150px; /* Ajusta o tamanho da logo para telas pequenas */
  }

  /* Centraliza a logo */
  align-self: center; /* Garante que a logo será centralizada no container */
`;

export const LogoCanto = styled.img`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 70px;

 @media (max-width: 800px) {
  width: 60px;
  max-width: 180px;
}

@media (max-width: 400px) {
  width: 55px;
  max-width: 150px;
}

@media (max-width: 355px) {
  width: 50px;
  max-width: 130px;
}

`;



export const AdditionalLinks = styled.div`
  position: absolute;
  top: 20px; /* Ajuste conforme necessário */
  right: 20px; /* Ajuste conforme necessário */
`;

export const Link = styled.a`
  color: #0C2B6E; /* Cor do texto */
  text-decoration: none; /* Remover sublinhado */
  font-size: 16px; /* Tamanho do texto */
  font-weight: bold; /* Peso da fonte */
  /* Adicione mais estilos conforme necessário */
`;